import React, { useState } from 'react';
import { X } from 'lucide-react';

const VALIDE = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;
export const splitEmails = (v) => [...new Set(String(v || '').split(/[,;\s]+/).map((e) => e.trim()).filter(Boolean))];

// Plusieurs destinataires : Entrée, virgule ou point-virgule pour ajouter ; collage d'une liste accepté.
export const EmailsInput = ({ value, onChange }) => {
  const emails = splitEmails(value);
  const [draft, setDraft] = useState('');
  const commit = (txt) => {
    const nouv = splitEmails(txt);
    if (nouv.length) onChange([...new Set([...emails, ...nouv])].join(', '));
    setDraft('');
  };
  const remove = (e) => onChange(emails.filter((x) => x !== e).join(', '));
  return (
    <div className="flex flex-wrap items-center gap-1.5 rounded-md border border-input bg-white px-2 py-1.5 min-h-9" data-testid="ia-devis-email-to">
      {emails.map((e) => (
        <span key={e} className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs ${VALIDE.test(e) ? 'bg-violet-100 text-violet-800' : 'bg-red-100 text-red-700'}`} data-testid={`ia-devis-email-chip-${e}`}>
          {e}
          <button type="button" onClick={() => remove(e)} aria-label={`Retirer ${e}`} data-testid={`ia-devis-email-remove-${e}`}><X className="h-3 w-3" /></button>
        </span>
      ))}
      <input
        value={draft}
        onChange={(ev) => (/[,;\s]$/.test(ev.target.value) ? commit(ev.target.value) : setDraft(ev.target.value))}
        onKeyDown={(ev) => { if (ev.key === 'Enter') { ev.preventDefault(); commit(draft); } if (ev.key === 'Backspace' && !draft && emails.length) remove(emails[emails.length - 1]); }}
        onBlur={() => commit(draft)}
        onPaste={(ev) => { ev.preventDefault(); commit(ev.clipboardData.getData('text')); }}
        placeholder={emails.length ? 'Ajouter une adresse…' : 'adresse@exemple.fr, autre@exemple.fr'}
        className="flex-1 min-w-[140px] text-sm outline-none bg-transparent"
        data-testid="ia-devis-email-add-input"
      />
    </div>
  );
};
